import { graphHooks } from '@tunasong/graph-lib/react'
import { useCurrentUser } from '@tunasong/redux'
import type { Entity, Persisted } from '@tunasong/schemas'

interface UseTrash {
  pageSize?: number
}
export const useTrash = ({ pageSize = 50 }: UseTrash) => {
  const { userId } = useCurrentUser()

  const { entities, isFetching, isLoading, isComplete, resetIncrementalState, getNext } = graphHooks.useEntitiesInc<
    Persisted<Entity>
  >({
    trash: true,
    pageSize,
  })

  const trashed = Object.values(entities ?? {})
    .filter(e => e.userId === userId)
    .filter(e => e.trash)

  return { trashed, isFetching, isLoading, getNext, isComplete, reload: resetIncrementalState }
}
